"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlarmsPage = AlarmsPage;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var alarms_1 = require("../components/dashboard/alarms");
var pagination_1 = require("../constants/pagination");
var routes_1 = require("../constants/routes");
var alarm_1 = require("../features/apis/alarm");
var use_sort_descriptor_1 = require("../hooks/use-sort-descriptor");
var hooks_1 = require("../store/hooks");
var client_scoped_query_1 = require("../utils/client-scoped-query");
var facility_scoped_query_1 = require("../utils/facility-scoped-query");
var paginated_content_1 = require("../utils/paginated-content");
var use_debounce_1 = require("../utils/use-debounce");
var use_has_permission_1 = require("../utils/use-has-permission");
function AlarmsPage() {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m;
    var COUNT_ONLY_SIZE = 1;
    var navigate = (0, react_router_dom_1.useNavigate)();
    var clientId = (0, client_scoped_query_1.useActiveClientId)();
    var facilityId = (0, facility_scoped_query_1.useActiveFacilityId)();
    var userId = (0, hooks_1.useAppSelector)(function (state) { var _a; return (_a = state.user.user) === null || _a === void 0 ? void 0 : _a._uid; });
    var canAcknowledgeAlarms = (0, use_has_permission_1.useHasPermission)("update_alarms");
    var _o = (0, react_1.useState)(""), search = _o[0], setSearch = _o[1];
    var debouncedSearch = (0, use_debounce_1.useDebouncedValue)(search);
    var _p = (0, react_1.useState)(pagination_1.DEFAULT_PAGE_NUMBER), page = _p[0], setPage = _p[1];
    var resetPage = (0, react_1.useCallback)(function () { return setPage(pagination_1.DEFAULT_PAGE_NUMBER); }, []);
    var _q = (0, use_sort_descriptor_1.useSortDescriptor)(resetPage), sortDescriptor = _q.sortDescriptor, onSortChange = _q.onSortChange, sortBy = _q.sortBy, sortDirection = _q.sortDirection;
    var _r = (0, react_1.useState)(pagination_1.DEFAULT_PAGE_SIZE), pageSize = _r[0], setPageSize = _r[1];
    var _s = (0, alarm_1.useGetAlarmsQuery)({
        clientId: clientId,
        facilityId: facilityId,
        userId: userId !== null && userId !== void 0 ? userId : "",
        size: pageSize,
        pageNumber: page,
        search: debouncedSearch || undefined,
        sortBy: sortBy,
        sortDirection: sortDirection,
    }, { skip: !facilityId }), currentData = _s.currentData, isLoading = _s.isLoading, isFetching = _s.isFetching, isError = _s.isError, error = _s.error, refetch = _s.refetch;
    var activeData = (0, alarm_1.useGetAlarmsQuery)({
        clientId: clientId,
        facilityId: facilityId,
        userId: userId !== null && userId !== void 0 ? userId : "",
        size: COUNT_ONLY_SIZE,
        pageNumber: pagination_1.DEFAULT_PAGE_NUMBER,
        statuses: ["ACTIVE"],
    }, { skip: !facilityId }).currentData;
    var acknowledgedData = (0, alarm_1.useGetAlarmsQuery)({
        clientId: clientId,
        facilityId: facilityId,
        userId: userId !== null && userId !== void 0 ? userId : "",
        size: COUNT_ONLY_SIZE,
        pageNumber: pagination_1.DEFAULT_PAGE_NUMBER,
        statuses: ["ACKNOWLEDGED"],
    }, { skip: !facilityId }).currentData;
    var resolvedData = (0, alarm_1.useGetAlarmsQuery)({
        clientId: clientId,
        facilityId: facilityId,
        userId: userId !== null && userId !== void 0 ? userId : "",
        size: COUNT_ONLY_SIZE,
        pageNumber: pagination_1.DEFAULT_PAGE_NUMBER,
        statuses: ["RESOLVED"],
    }, { skip: !facilityId }).currentData;
    var acknowledgeAlarm = (0, alarm_1.useAcknowledgeAlarmMutation)()[0];
    var alarms = (0, react_1.useMemo)(function () { return (0, paginated_content_1.getContentItems)(currentData); }, [currentData]);
    (0, react_1.useEffect)(function () {
        setPage(pagination_1.DEFAULT_PAGE_NUMBER);
    }, [facilityId, debouncedSearch, pageSize]);
    var total = (_c = (_b = (_a = currentData === null || currentData === void 0 ? void 0 : currentData.content) === null || _a === void 0 ? void 0 : _a.pagination) === null || _b === void 0 ? void 0 : _b.totalItems) !== null && _c !== void 0 ? _c : alarms.length;
    var activeCount = (_f = (_e = (_d = activeData === null || activeData === void 0 ? void 0 : activeData.content) === null || _d === void 0 ? void 0 : _d.pagination) === null || _e === void 0 ? void 0 : _e.totalItems) !== null && _f !== void 0 ? _f : 0;
    var acknowledgedCount = (_j = (_h = (_g = acknowledgedData === null || acknowledgedData === void 0 ? void 0 : acknowledgedData.content) === null || _g === void 0 ? void 0 : _g.pagination) === null || _h === void 0 ? void 0 : _h.totalItems) !== null && _j !== void 0 ? _j : 0;
    var resolvedCount = (_m = (_l = (_k = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.content) === null || _k === void 0 ? void 0 : _k.pagination) === null || _l === void 0 ? void 0 : _l.totalItems) !== null && _m !== void 0 ? _m : 0;
    var totalKnownCount = activeCount + acknowledgedCount + resolvedCount;
    var activeAlarmsOnPage = (0, react_1.useMemo)(function () { return alarms.filter(function (alarm) { return alarm.status === "ACTIVE"; }); }, [alarms]);
    var summaryTiles = (0, react_1.useMemo)(function () { return [
        { label: "Total Alarms", value: String(total), icon: "solar:bell-linear", tone: "neutral" },
        { label: "Active", value: String(activeCount), icon: "solar:danger-triangle-linear", tone: "critical" },
        {
            label: "Acknowledged",
            value: String(acknowledgedCount),
            icon: "solar:shield-check-linear",
            tone: "warning",
            helperText: totalKnownCount ? "".concat(Math.round((acknowledgedCount / totalKnownCount) * 100), "% of total alarms") : undefined,
            progressPercent: totalKnownCount ? Math.round((acknowledgedCount / totalKnownCount) * 100) : 0,
        },
        {
            label: "Resolved",
            value: String(resolvedCount),
            icon: "solar:check-circle-linear",
            tone: "success",
            helperText: totalKnownCount ? "".concat(Math.round((resolvedCount / totalKnownCount) * 100), "% of total alarms") : undefined,
            progressPercent: totalKnownCount ? Math.round((resolvedCount / totalKnownCount) * 100) : 0,
        },
    ]; }, [total, activeCount, acknowledgedCount, resolvedCount, totalKnownCount]);
    var handleAcknowledge = function (id) {
        acknowledgeAlarm(id);
    };
    var handleAcknowledgeAll = function () {
        activeAlarmsOnPage.forEach(function (alarm) { return acknowledgeAlarm(alarm.id); });
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-4", children: [(0, jsx_runtime_1.jsx)(alarms_1.AlarmsHeader, { search: search, onSearchChange: setSearch, hasActiveAlarms: activeAlarmsOnPage.length > 0, onAcknowledgeAll: handleAcknowledgeAll, canAcknowledgeAll: canAcknowledgeAlarms }), (0, jsx_runtime_1.jsx)(alarms_1.AlarmSummaryCards, { tiles: summaryTiles }), (0, jsx_runtime_1.jsx)(alarms_1.AlarmsTable, { alarms: alarms, isLoading: isLoading || !facilityId || (isFetching && !currentData), isFetching: isFetching, isError: isError, error: error, onRetry: refetch, onAcknowledge: handleAcknowledge, onView: function (alarm) { return navigate((0, react_router_dom_1.generatePath)(routes_1.ROUTES.ALARM_VIEW, { id: alarm.id })); }, canAcknowledge: canAcknowledgeAlarms, sortDescriptor: sortDescriptor, onSortChange: onSortChange, page: page, pageSize: pageSize, total: total, onPageChange: setPage, onPageSizeChange: setPageSize })] }));
}
